var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSource = function SvgSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.004 12.005H7.003A4.002 4.002 0 0 1 3 8.004v0a4.002 4.002 0 0 1 4.002-4.002h2M14.006 4.002h2a4.002 4.002 0 0 1 4.002 4.002v0M7.003 8.003h8.003"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.007,
    cy: 15.007,
    r: 4.002,
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12.005 20.008 2.173-2.173"
  })));
};
export { SvgSource as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNTFjYjEwOGY5MjA5NWFhNTcyNmYyNTRkNzcwMmFmNTAuc3ZnIjs=";